import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

import useTranslate from '../../../../common/hooks/useTranslate';
import { useSelector, useDispatch } from 'react-redux';

import Axios from 'axios';
import { generateDocuSignURL } from '../../../services/docuSignService';

import { RootState } from '../../../../redux/store';
import { POPUP, MODAL } from '../../../../redux/types';

import { IDocuSignUri } from '../../../docuSign/types/IDocuSignUri';

import { Orbit } from '@uiball/loaders';
import Icon from '../../icon/icon';

import './docuSignLoadingModal.scss';

const modalElement = document.getElementById('modal-root');

export const DocuSignLoadingModal: React.FC = () => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const modalRef = useRef(null);

  const showRedirectingModal = useSelector((state: RootState) => state.redirectingModal.showRedirectingModal);
  const currentRedirectingItem = useSelector((state: RootState) => state.redirectingModal.currentItem);

  const source = Axios.CancelToken.source();
  const cancelToken = source.token;

  const close = () => {
    dispatch({ type: MODAL.SWITCH_REDIRECTING_TO_DS_MODAL });
    source.cancel();
  };

  useEffect(() => {
    if (showRedirectingModal) {
      generateDocuSignURL(+currentRedirectingItem.recipientId, cancelToken)
        .then((res: IDocuSignUri) => {
          location.href = res.uri;
        })
        .catch((err) => {
          dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message });
          dispatch({ type: MODAL.SWITCH_REDIRECTING_TO_DS_MODAL });
          if (Axios.isCancel(err)) {
            console.log('Post request cancelled');
          }
        });
    }
  }, [showRedirectingModal]);

  return createPortal(
    showRedirectingModal ? (
      <div className={`modal`}>
        <div className='modal-body' ref={modalRef}>
          <div className={'modal-title'}>
            <Icon name='fas fa-xmark' className='impersonate-off-icon pointer' onClick={close} />
          </div>
          <div className='modal-info'>
            <h2>{t('DOCUSIGN.REDIRECTING_TO_DOCUSIGN')}</h2>
            <Orbit size={25} speed={1.5} color='black' />
          </div>
        </div>
      </div>
    ) : null,
    modalElement,
  );
};

export default DocuSignLoadingModal;
